import { render } from "./ModalUpdateNew.vue?vue&type=template&id=65de2be1&scoped=true"
import script from "./ModalUpdateNew.vue?vue&type=script&lang=js"
export * from "./ModalUpdateNew.vue?vue&type=script&lang=js"

import "./ModalUpdateNew.vue?vue&type=style&index=0&id=65de2be1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65de2be1"]])

export default __exports__